<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-7 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">Item Master List</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto">
            <div class="row mt-3 align-items-center">
              <div class="col-lg-6 col-12">
                <input
                  class="nosubmit"
                  type="search"
                  id="keyword_search"
                  v-model="searchKeyword"
                  extraClass
                  name="keyword_search"
                  placeholder="Search item no, item name..."
                  @input="onChangesearchKeyword"
                />
              </div>
              <div class="col-lg-3 col-6 d-flex justify-content-center mt-3">
                <div
                  class="cursor-pointer"
                  :class="{
                    'title-page fs-16 text-decoration-underline':
                      itemType === 0,
                  }"
                  @click="changeItemType(0)"
                >
                  All
                </div>
                <div class="mx-3">|</div>
                <div
                  class="cursor-pointer"
                  :class="{
                    'title-page fs-16 text-decoration-underline':
                      itemType === 1,
                  }"
                  @click="changeItemType(1)"
                >
                  Menu Item
                </div>
                <div class="mx-3">|</div>
                <div
                  class="cursor-pointer"
                  :class="{
                    'title-page fs-16 text-decoration-underline':
                      itemType === 2,
                  }"
                  @click="changeItemType(2)"
                >
                  Modifier
                </div>
              </div>
              <div class="col-lg-3 col-6 d-flex justify-content-end">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    style="margin-top: 13px"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    {{ $t("download") }}
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('csv')"
                        href="#"
                        >Export CSV</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('xlsx')"
                        href="#"
                        >Export Excel</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="row">
                <div class="col-lg-9 col-12 d-flex align-items-center mb-2">
                  <div class="label-header">
                    Showing {{ pagination.number_items }} of
                    {{ pagination.total }} Items
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-3 d-flex justify-content-end">
                  <ShowHideColumn
                    :columns="columns"
                    :changeCheckbox="changeCheckbox"
                    :columnCheckedCache="columnChecked"
                    :key="key"
                  />
                </div>
              </div>
              <div class="col-12" v-if="isLoadData">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr class="text-left font-weight-bold">
                            <th class="w-5"></th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="w-10"
                                v-if="columnShowed.includes(item.field)"
                              >
                                <span
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    () => {
                                      !!item.hasSortBy &&
                                        handleChangeSortColumn(index + 1);
                                    }
                                  "
                                  >{{ item.label }}</span
                                >
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="itemList.length">
                          <tr v-for="(item, key) in itemList" :key="key">
                            <td class="text-center text-xss w-5">
                              <i
                                class="fa fa-ellipsis-v text-secondary cursor-pointer dropdownMenuButton"
                                aria-hidden="true"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                              ></i>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <li>
                                  <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="editItem(item.id)"
                                  >
                                    <i class="material-icons me-1">edit</i>
                                    <span>Edit</span>
                                  </a>
                                </li>
                              </ul>
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('image')"
                            >
                              <img
                                :src="item.image"
                                width="70"
                                height="70"
                                alt="Image"
                              />
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('last_updated')"
                            >
                              {{
                                item.last_updated
                                  ? formatDate(item.last_updated)
                                  : ""
                              }}
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('item_no')"
                            >
                              {{ item.item_no }}
                            </td>
                            <td
                              class="text-left text-xss w-10 td-limit-width"
                              v-if="columnShowed.includes('item_name')"
                            >
                              {{ item.item_name }}
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('barcode')"
                            >
                              {{ item.barcode }}
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('barcode2')"
                            >
                              {{ item.barcode2 }}
                            </td>
                            <td
                              class="text-left text-xss td-limit-width w-10"
                              v-if="columnShowed.includes('description')"
                            >
                              {{ item.description }}
                            </td>
                            <td
                              class="text-left text-xss td-limit-width w-10"
                              v-if="columnShowed.includes('pos_name')"
                            >
                              {{ item.pos_name }}
                            </td>
                            <td
                              class="text-left text-xss td-limit-width w-10"
                              v-if="columnShowed.includes('pos_description')"
                            >
                              {{ item.pos_description }}
                            </td>
                            <template
                              v-for="(price, index) in normalizePrices(
                                item.prices
                              )"
                              :key="'price-' + index"
                            >
                              <td
                                v-if="
                                  columnShowed.includes('price_' + (index + 1))
                                "
                                class="text-left text-xss w-10"
                              >
                                {{ price ? formatPrice(price.price) : "" }}
                              </td>
                            </template>
                            <template
                              v-for="(price, index) in normalizePrices(
                                item.platform_prices
                              )"
                              :key="'platform-' + index"
                            >
                              <td
                                v-if="
                                  columnShowed.includes(
                                    'platform_price_' + (index + 1)
                                  )
                                "
                                class="text-left text-xss w-10"
                              >
                                {{ price ? formatPrice(price.price) : "" }}
                              </td>
                            </template>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('printers')"
                            >
                              <div
                                v-for="group in item.printer_groups"
                                :key="group.menuset_id"
                                class="printer-group"
                              >
                                <div class="printer-group-name">
                                  {{ group.menuset_name }}
                                </div>
                                <div
                                  v-for="printer in group.printers"
                                  :key="printer.printer_id"
                                  class="printer-tag"
                                >
                                  {{ printer.printer_name }}
                                </div>
                              </div>
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('type_name')"
                            >
                              {{ item.type_name }}
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('group_name')"
                            >
                              {{ item.group_name }}
                            </td>
                            <td
                              class="text-left text-xss w-10"
                              v-if="columnShowed.includes('item_type')"
                            >
                              {{ item.item_type }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="20" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3"
                  >
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select
                          v-model="limit"
                          @change="setLimitPerPage"
                          class="rows-per-page__select"
                        >
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                          <option :value="200">200</option>
                          <option :value="500">500</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
      <ModalConfirmDelete
        message="Are you sure you want to delete?"
        :process-yes="deleteItemList"
      />
      <AddItemModal
        :keyReload="keyReloadAddItem"
        :isEditItem="isEditItem"
        :categoryId="categoryIdSelect"
        @reload-list-category="getList(page)"
      ></AddItemModal>
    </div>
    <form :action="`${actionDownload}/merchant/item/export`" method="POST">
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="item_type" :value="itemType" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
// import MaterialButton from "@/components/MaterialButton.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vueform/multiselect/themes/default.css";
import ItemService from "../../services/product/item.service";
// import Multiselect from "@vueform/multiselect";
import TokenService from "../../services/token.service";
import $ from "jquery";
// import { saveAs } from "file-saver";
import ModalConfirmDelete from "@/components/ModalConfirmDelete.vue";
import { formatPrice } from "@/config/utils";
import AddItemModal from "@/components/AddItem.vue";
import ShowHideColumn from "@/components/ShowHideColumn.vue";

export default {
  name: "campaign-list",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    // MaterialButton,
    Pagination,
    // Multiselect,
    ModalConfirmDelete,
    AddItemModal,
    ShowHideColumn,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      pagination: {},
      page: 1,
      isLoadData: false,
      itemList: [],
      selectedItems: [],
      item_name: "",
      action: "list",
      action_export: "excel",
      searchKeyword: "",
      itemType: 0, // 1: Main, 2: Modifier
      keyReloadAddItem: "key-reload-add-item",
      isEditItem: 0,
      limit: 50,
      columns: [
        { value: "all", label: "All" },
        { value: "image", label: "Image" },
        { value: "last_updated", label: "Last Updated" },
        { value: "item_no", label: "Item No" },
        { value: "item_name", label: "Name" },
        { value: "barcode", label: "Barcode" },
        { value: "barcode2", label: "Barcode 2" },
        { value: "description", label: "Description" },
        { value: "pos_name", label: "POS English Name" },
        { value: "pos_description", label: "POS Name 2" },
        { value: "price_1", label: "Price 1" },
        { value: "price_2", label: "Price 2" },
        { value: "price_3", label: "Price 3" },
        { value: "platform_price_1", label: "Grab" },
        { value: "platform_price_2", label: "Panda" },
        { value: "platform_price_3", label: "Deliveroo" },
        { value: "printers", label: "Printers" },
        { value: "type_name", label: "Report Type" },
        { value: "group_name", label: "Report Group" },
        { value: "item_type", label: "Type" },
      ],
      columnShowed: [],
      columnChecked: [],
      ESortDirectionSelect: {
        idx: null,
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
    };
  },
  created() {
    if (window.localStorage.getItem("ItemMasterColumn")) {
      this.columnChecked = window.localStorage
        .getItem("ItemMasterColumn")
        .split(",");
      this.key = Math.random();
    }

    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }

    this.getList(this.page);
  },
  computed: {
    headersData() {
      return [
        {
          label: "Image",
          field: "image",
          hasSortBy: false,
        },
        {
          label: "Last Updated",
          field: "last_updated",
          hasSortBy: false,
        },
        {
          label: "Item No",
          field: "item_no",
          hasSortBy: false,
        },
        {
          label: "Name",
          field: "item_name",
          hasSortBy: false,
        },
        {
          label: "Barcode",
          field: "barcode",
          hasSortBy: false,
        },
        {
          label: "Barcode 2",
          field: "barcode2",
          hasSortBy: false,
        },
        {
          label: "Description",
          field: "description",
          hasSortBy: false,
        },
        {
          label: "POS English Name",
          field: "pos_name",
          hasSortBy: false,
        },
        {
          label: "POS Name 2",
          field: "pos_description",
          hasSortBy: false,
        },
        {
          label: "Price 1",
          field: "price_1",
          hasSortBy: false,
        },
        {
          label: "Price 2",
          field: "price_2",
          hasSortBy: false,
        },
        {
          label: "Price 3",
          field: "price_3",
          hasSortBy: false,
        },
        {
          label: "Grab",
          field: "platform_price_1",
          hasSortBy: false,
        },
        {
          label: "Panda",
          field: "platform_price_2",
          hasSortBy: false,
        },
        {
          label: "Deliveroo",
          field: "platform_price_3",
          hasSortBy: false,
        },
        {
          label: "Printers",
          field: "printers",
          hasSortBy: false,
        },
        {
          label: "Report Type",
          field: "type_name",
          hasSortBy: false,
        },
        {
          label: "Report Group",
          field: "group_name",
          hasSortBy: false,
        },
        {
          label: "Type",
          field: "item_type",
          hasSortBy: false,
        },
      ];
    },
  },
  methods: {
    normalizePrices(prices, total = 3) {
      const result = prices ? [...prices] : [];
      while (result.length < total) {
        result.push(null);
      }
      return result.slice(0, total);
    },
    formatDate(date) {
      return new Date(date).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    formatPrice,

    changeItemType(type) {
      this.itemType = type;
      this.getList(this.page);
    },

    exportFile(type = "csv") {
      if (this.columnShowed.length == 0) {
        this.snackbar = "danger";
        this.message = "You must select least 1 column to export file.";
        this.setTimeOutNotification();
      } else {
        this.action_export = type;
        setTimeout(() => {
          $("#downloadForm").click();
        }, 150);
      }
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList(this.page);
      }, 1000);
    },

    editItem(itemId) {
      this.isEditItem = itemId;
      this.keyReloadAddItem = Math.random();
      $("#show-modal-add-item").click();
    },

    getList(page) {
      this.isLoadData = false;
      this.showLoader();
      var dataForm = {
        page: page,
        item_type: this.itemType,
        search_keyword: this.searchKeyword,
        limit: this.limit,
      };

      ItemService.getList(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.itemList = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }

          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(this.page);
    },

    changeCheckbox(columnShowed) {
      this.columnShowed = columnShowed;
      window.localStorage.setItem("ItemMasterColumn", columnShowed);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>
<style scoped>
input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.fs-16 {
  font-size: 16px !important;
}

.label-header {
  font-size: 16px;
  color: #222;
  font-weight: 500;
}

.dropdown:not(.dropdown-hover) .dropdown-menu.show {
  margin-top: 3.5rem !important;
}

.td-limit-width {
  width: 200px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.printer-group + .printer-group {
  margin-top: 8px;
}

.printer-group-name {
  font-weight: 600;
  margin: 0 5px;
}

.printer-tag {
  background-color: #f5f5f5;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  padding: 2px 5px;
  margin: 5px;
}
</style>
